import './MaintenanceView.scss';
import React from 'react';
import { EMAILS, MAINTENANCE_COPY, URLS } from '@sonar-software/sonar-ts-constants';
import { GatewayCard, GatewayContent } from '../general';
export const MaintenanceView = () => React.createElement(GatewayContent, null,
    React.createElement(GatewayCard, { className: 'maintenance-view', title: MAINTENANCE_COPY.PAGE_HEADER },
        React.createElement("div", { className: 'maintenance-image' }),
        React.createElement("p", null,
            MAINTENANCE_COPY.PAGE_SUBTEXT_PARTIAL_1,
            React.createElement("a", { href: URLS.SUPPORT_EMAIL, rel: 'noopener', target: '_blank' }, EMAILS.SUPPORT),
            MAINTENANCE_COPY.PAGE_SUBTEXT_PARTIAL_2)));
